import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'common/localization';
import AriaModal from 'react-aria-modal';
import Button from 'common/components/atoms/button';
import useStyleOverrides from 'common/components/hooks/use-style-overrides';
import baseStyles from 'commonStyles/components/modal/_modal';
import siteStyles from 'styles/components/modal/_modal';

const getApplicationNodeProp = () => document.getElementsByClassName('body-wrap')[0];
const openModals = new Set();

const Modal = (props) => {
  const {
    id,
    showModal,
    modalTitle,
    overlayClass,
    modalContentClass,
    firstFocusElement,
    onExitFn,
    children,
    closeButton,
  } = props;

  const styles = useStyleOverrides(baseStyles, siteStyles);
  const idRef = useRef(id);

  useEffect(() => {
    if (showModal) {
      openModals.add(idRef.current);
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      removeStylesModal();
    }

    return removeStylesModal;
  }, [showModal]);

  const removeStylesModal = () => {
    openModals.delete(idRef.current);
    if (openModals.size === 0) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  };

  return (
    <AriaModal
      titleText={modalTitle}
      mounted={showModal}
      onExit={onExitFn}
      underlayClass={`${styles.modalOverlay} ${overlayClass}`}
      dialogClass={`${styles.modalInnerWrap} ${modalContentClass}`}
      initialFocus={firstFocusElement}
      includeDefaultStyles={false}
      getApplicationNode={getApplicationNodeProp}
      aria-modal="true"
      underlayClickExits
      scrollDisabled={false}
    >
      {closeButton ?
        <Button
          reset
          className={styles.closeButton}
          onClick={onExitFn}
        >
          <span className="visually-hidden">{translate('label.close')}</span>
        </Button> : null
      }
      {children}
    </AriaModal>
  );
};

Modal.propTypes = {
  id: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string.isRequired,
  firstFocusElement: PropTypes.string,
  overlayClass: PropTypes.string,
  modalContentClass: PropTypes.string,
  onExitFn: PropTypes.func.isRequired,
  closeButton: PropTypes.bool,
};

export default Modal;
